// extracted by mini-css-extract-plugin
export default {"trigger":"dropdown_trigger__2aeeP","arrow":"dropdown_arrow__5H9tl","content":"dropdown_content__4oT-g","item":"dropdown_item__AMtyA"};